import "./LedgerEntryModal.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import {

    useState,
    useMemo,
    useEffect

} from "react";

import {

    X,

    Landmark,

    Calendar,

    Wallet,

    Receipt,

    ArrowDownCircle,

    ArrowUpCircle,

    RefreshCcw,

    CircleDollarSign,

    FileText,

    StickyNote,

    ShieldCheck,

    Repeat,

   
    CheckCircle2,

    XCircle

} from "lucide-react";

import CountUp from "react-countup";

import { toast } from "react-toastify";

import api from "../../api";


export default function LedgerEntryModal({

    open,

    onClose,

    currentBalance = 0,

    refreshLedger,

    editingEntry = null

}){


    /* ======================================
            CATEGORY ENGINE
    ====================================== */

    const CATEGORY_TYPES = {

        DEPOSIT:{

            color:"gold",

            impact:"CREDIT",

            types:[

                "Cash Deposit",

                "Transfer In",

                "Interest Earned",

                "Refund",

                "Other Deposit"

            ]

        },

        PAYMENT:{

            color:"green",

            impact:"DEBIT",

            types:[

                "Transfer Out",

                "Supplier Payment",

                "Loan Payment",

                "MMG Float",

                "Utility Payment",

                "Other Payment"

            ]

        },

        WITHDRAWAL:{

    color:"red",

    impact:"DEBIT",

    types:[

        "Cash Withdrawal",

        "ATM Withdrawal",

        "Counter Withdrawal",

        "Transfer Withdrawal",

        "Other Withdrawal"

    ]

},

CARD_PAYMENT:{

    color:"purple",

    impact:"DEBIT",

    types:[

        "POS Purchase",

        "Online Purchase",

        "Subscription",

        "Card Fee",

        "Other Card Payment"

    ]

},

        EXPENSE:{

            color:"red",

            impact:"DEBIT",

            types:[

                "Bank Charge",

                "Salary",

                "Fuel",

                "Office Expense",

                "Misc Expense"

            ]

        },

        ADJUSTMENT:{

            color:"orange",

            impact:"SMART",

            types:[

                "Opening Balance",

                "Manual Credit",

                "Manual Debit",

                "Correction",

                "Reversal"

            ]

        }

    };

    /* ======================================
            FORM
    ====================================== */

    const [

        form,

        setForm

    ] = useState({

        entryDate:

        new Date()

        .toISOString()

        .slice(0,10),

        bankAccount:"PRIMARY",

        category:"",

        entryType:"",

        description:"",

systemReference:"Auto Generated",

externalReference:"",

        amount:"",

        notes:"",

        reconciled:false,

        approval:false,

        recurring:false

    });

    const [

        saving,

        setSaving

    ] = useState(false);

/* ======================================
        RESET / EDIT MODE
====================================== */

useEffect(()=>{

    if(!open)
        return;

    if(editingEntry){

        const amount =

            editingEntry.credit > 0

            ?

            editingEntry.credit

            :

            editingEntry.debit;

        setForm({

entryDate:

    editingEntry.date

        ?

        new Date(

            editingEntry.date

        )

        .toISOString()

        .slice(0,10)

        :

        "",

            bankAccount:

                "PRIMARY",

            category:

                editingEntry.category,

            entryType:

                editingEntry.type,

            description:

                editingEntry.description,

            systemReference:

                editingEntry.reference,

            externalReference:

                editingEntry.externalReference || "",

            amount,

            notes:

                editingEntry.notes || "",

            reconciled:false,

            approval:false,

            recurring:false

        });

    }

    else{

        setForm({

            entryDate:

                new Date()

                .toISOString()

                .slice(0,10),

            bankAccount:"PRIMARY",

            category:"",

            entryType:"",

            description:"",

            systemReference:"Auto Generated",

            externalReference:"",

            amount:"",

            notes:"",

            reconciled:false,

            approval:false,

            recurring:false

        });

    }

},[

    open,

    editingEntry

]);

    /* ======================================
            HANDLE CHANGE
    ====================================== */

    function updateField(

        field,

        value

    ){

        setForm(prev=>({

            ...prev,

            [field]:value

        }));

    }

    /* ======================================
            TYPES
    ====================================== */

    const availableTypes = useMemo(()=>{

        if(

            !form.category

        )

            return [];

        return CATEGORY_TYPES[

            form.category

        ].types;

    },[form.category]);

    /* ======================================
            DEBIT CREDIT
    ====================================== */

    const amount =

        Number(form.amount)||0;

    let debit = 0;

    let credit = 0;

    let impact = "";

    switch(

        form.category

    ){

        case "DEPOSIT":

            credit=amount;

            impact="CREDIT";

        break;

        case "EXPENSE":

            debit=amount;

            impact="DEBIT";

        break;

case "PAYMENT":

case "WITHDRAWAL":

case "CARD_PAYMENT":

    debit = amount;

    impact = "DEBIT";

break;

        case "ADJUSTMENT":

            if(

                form.entryType==="Manual Credit"

            ){

                credit=amount;

                impact="CREDIT";

            }

            else{

                debit=amount;

                impact="DEBIT";

            }

        break;

        default:

            break;

    }

    /* ======================================
            PROJECTED BALANCE
    ====================================== */

    const projectedBalance =

        currentBalance

        +

        credit

        -

        debit;

    /* ======================================
            VALIDATION
    ====================================== */

    const valid =

        form.entryDate &&

        form.category &&

        form.entryType &&

        form.description &&

        amount>0;

    /* ======================================
            SAVE
    ====================================== */

    async function saveEntry(){

        if(!valid){

            toast.error(

                "Complete all required fields."

            );

            return;

        }

        try{

            setSaving(true);

const payload = {

    entry_date:

        form.entryDate,

    bank_account:

        form.bankAccount,

    category:

        form.category,

    entry_type:

        form.entryType,

    description:

        form.description,

    external_reference:

        form.externalReference,

    debit,

    credit,

    notes:

        form.notes,

    transaction_source:

        "MANUAL"

};

if(editingEntry){

    await api.updateBankLedgerEntry(

        editingEntry.id,

        payload

    );

}

else{

    await api.createBankLedgerEntry(

        payload

    );

}
toast.success(

    editingEntry

    ?

    "Ledger Entry Updated"

    :

    "Ledger Entry Added"

);

            refreshLedger();

            onClose();

        }

        catch(err){

            console.error(err);

            toast.error(

                "Unable to save ledger entry."

            );

        }

        finally{

            setSaving(false);

        }

    }

if(!open){

    return null;

}

return(

<div className="ledger-modal-overlay">

    <div className="ledger-modal">

        {/* =====================================
                HEADER
        ====================================== */}

        <div className="ledger-header">

            <div>

                <div className="ledger-pill">

                    <Landmark size={15}/>

                    BANK LEDGER

                </div>

<h2>

    {

        editingEntry

        ?

        "Edit Ledger Entry"

        :

        "New Ledger Entry"

    }

</h2>

<p>

{

editingEntry

?

"Modify the editable details of this ledger entry."

:

"Create a manual transaction that will affect the bank ledger."

}

</p>
            </div>

            <button

                className="ledger-close"

                onClick={onClose}

            >

                <X size={20}/>

            </button>

        </div>


        {/* =====================================
                BODY
        ====================================== */}

        <div className="ledger-body">

            {/* ===========================
                    LEFT
            ============================ */}

            <div className="ledger-left">






{

editingEntry &&

<div className="ledger-section">

    <h3>

        Entry Information

    </h3>

    <div className="ledger-grid">

        <div>

            <label>

                Entry Number

            </label>

            <input

                type="text"

                value={editingEntry.entryNumber}

                readOnly

                className="readonly-field"

            />

        </div>

        <div>

            <label>

                Source

            </label>

            <input

                type="text"

                value={editingEntry.source}

                readOnly

                className="readonly-field"

            />

        </div>

    </div>

    <div className="ledger-grid">

        <div>

            <label>

                System Reference

            </label>

            <input

                type="text"

                value={editingEntry.reference}

                readOnly

                className="readonly-field"

            />

        </div>

        <div>

            <label>

                Created By

            </label>

            <input

                type="text"

                value={editingEntry.createdBy || "-"}

                readOnly

                className="readonly-field"

            />

        </div>

    </div>

    <div className="ledger-grid">

        <div>

            <label>

                Created

            </label>

            <input

                type="text"

                value={

                    editingEntry.createdAt

                    ?

                    new Date(

                        editingEntry.createdAt

                    ).toLocaleString()

                    :

                    "-"

                }

                readOnly

                className="readonly-field"

            />

        </div>

        <div>

            <label>

                Last Updated

            </label>

            <input

                type="text"

                value={

                    editingEntry.updatedAt

                    ?

                    new Date(

                        editingEntry.updatedAt

                    ).toLocaleString()

                    :

                    "-"

                }

                readOnly

                className="readonly-field"

            />

        </div>

    </div>

</div>

}



                {/* TRANSACTION */}

                <div className="ledger-section">

                    <h3>

                        Transaction Information

                    </h3>

                    <div className="ledger-grid">

                        <div>

                            <label>

                                Date

                            </label>

<DatePicker

    selected={
        form.entryDate
            ? new Date(form.entryDate)
            : null
    }

    onChange={(date)=>{

        if(!date) return;

        updateField(
            "entryDate",
            date.toISOString().slice(0,10)
        );

    }}

    dateFormat="dd MMM yyyy"

    showPopperArrow={false}

    popperPlacement="bottom-start"

    calendarClassName="ledger-calendar"

    wrapperClassName="ledger-datepicker-wrapper"

    className={
        editingEntry
            ? "readonly-field"
            : "ledger-datepicker"
    }

    disabled={!!editingEntry}

/>
                        </div>

                        <div>

                            <label>

                                Bank Account

                            </label>
<select

    value={form.bankAccount}

    disabled={!!editingEntry}

    className={editingEntry ? "readonly-field" : ""}

    onChange={(e)=>

        updateField(

            "bankAccount",

            e.target.value

        )

    }

>

                                <option value="PRIMARY">

                                    Primary Account

                                </option>

                            </select>

                        </div>

                    </div>

                    <div className="ledger-grid">

                        <div>

                            <label>

                                Category

                            </label>

<select

    value={form.category}

    disabled={!!editingEntry}

    className={editingEntry ? "readonly-field" : ""}

    onChange={(e)=>{

        updateField(

            "category",

            e.target.value

        );

        updateField(

            "entryType",

            ""

        );

    }}

>

                                <option value="">

                                    Select Category

                                </option>

                                <option value="DEPOSIT">

                                    Deposit

                                </option>

<option value="PAYMENT">

    Payment

</option>

<option value="WITHDRAWAL">

    Withdrawal

</option>

<option value="CARD_PAYMENT">

    Card Payment

</option>

<option value="EXPENSE">

    Expense

</option>

                                <option value="ADJUSTMENT">

                                    Adjustment

                                </option>

                            </select>

                        </div>

                        <div>

                            <label>

                                Transaction Type

                            </label>

<select

    value={form.entryType}

    disabled={!!editingEntry}

    className={editingEntry ? "readonly-field" : ""}

    onChange={(e)=>

        updateField(

            "entryType",

            e.target.value

        )

    }

>

                                <option>

                                    Select Type

                                </option>

                                {

                                    availableTypes.map(

                                        type=>(

                                        <option

                                            key={type}

                                            value={type}

                                        >

                                            {type}

                                        </option>

                                    ))

                                }

                            </select>

                        </div>

                    </div>

                </div>


                {/* DETAILS */}

                <div className="ledger-section">

                    <h3>

                        Transaction Details

                    </h3>

                    <label>

                        Description

                    </label>

                    <input

                        type="text"

                        placeholder="Description"

                        value={form.description}

                        onChange={(e)=>

                            updateField(

                                "description",

                                e.target.value

                            )

                        }

                    />

                    <div className="ledger-grid">
<div>

    <label>

        System Reference

    </label>

    <input

        type="text"

        value="Generated Automatically"

        readOnly

        style={{

            background:"#f8fafc",

            color:"#64748b",

            cursor:"not-allowed"

        }}

    />

</div>

                        <div>

                            <label>

                                External Reference

                            </label>
<input

    type="text"

    placeholder="Cheque No., EFT No., Deposit Slip, MMG Ref..."

    value={form.externalReference}

    onChange={(e)=>

        updateField(

            "externalReference",

            e.target.value

        )

    }

/>
                        </div>

                    </div>

                </div>


                {/* FINANCIAL */}

                <div className="ledger-section">

                    <h3>

                        Financial Details

                    </h3>

                    <div className="ledger-grid">

                        <div>

                            <label>

                                Amount

                            </label>

                            <input

                                type="number"

                                min="0"

                                step="0.01"

                                value={form.amount}

                                onChange={(e)=>

                                    updateField(

                                        "amount",

                                        e.target.value

                                    )

                                }

                            />

                        </div>

                    </div>

                    <label>

                        Notes

                    </label>

                    <textarea

                        rows="5"

                        value={form.notes}

                        onChange={(e)=>

                            updateField(

                                "notes",

                                e.target.value

                            )

                        }

                    />

                </div>

            </div>


            {/* ===========================
                    RIGHT
            ============================ */}

            <div className="ledger-right">

                {/* IMPACT */}

                <div className="impact-card">

                    <div className="impact-header">

                        <CircleDollarSign size={22}/>

                        <h3>

                            Ledger Impact

                        </h3>

                    </div>

                    <div className={`impact-badge ${impact.toLowerCase()}`}>

                        {

                            impact ||

                            "Awaiting Selection"

                        }

                    </div>

                    <div className="impact-row">

                        <span>

                            Debit

                        </span>

                        <strong>

                            GYD

                            <CountUp

                                end={debit}

                                separator=","

                                decimals={2}

                            />

                        </strong>

                    </div>

                    <div className="impact-row">

                        <span>

                            Credit

                        </span>

                        <strong>

                            GYD

                            <CountUp

                                end={credit}

                                separator=","

                                decimals={2}

                            />

                        </strong>

                    </div>

                    <hr/>

                    <div className="impact-row">

                        <span>

                            Current Balance

                        </span>

                        <strong>

                            GYD

                            <CountUp

                                end={currentBalance}

                                separator=","

                                decimals={2}

                            />

                        </strong>

                    </div>

                    <div className="impact-arrow">

                        ↓

                    </div>

                    <div className="impact-balance">

                        <CountUp

                            end={projectedBalance}

                            separator=","

                            decimals={2}

                        />

                    </div>

                </div>

{/* VALIDATION */}

<div className="impact-card">

    <h3>

        Validation

    </h3>

    <div className={`check-item ${form.entryDate ? "complete" : "pending"}`}>
{
    form.entryDate
    ?
    <CheckCircle2 size={18}/>
    :
    <XCircle size={18}/>
}

        <span>

            {

                form.entryDate

                ?

                "Date Selected"

                :

                "Select Date"

            }

        </span>

    </div>

    <div className={`check-item ${form.category ? "complete" : "pending"}`}>

{
    form.entryDate
    ?
    <CheckCircle2 size={18}/>
    :
    <XCircle size={18}/>
}

        <span>

            {

                form.category

                ?

                "Category Selected"

                :

                "Select Category"

            }

        </span>

    </div>

    <div className={`check-item ${form.entryType ? "complete" : "pending"}`}>

{
    form.entryDate
    ?
    <CheckCircle2 size={18}/>
    :
    <XCircle size={18}/>
}

        <span>

            {

                form.entryType

                ?

                "Transaction Type Selected"

                :

                "Select Transaction Type"

            }

        </span>

    </div>

    <div className={`check-item ${form.description.trim() ? "complete" : "pending"}`}>

{
    form.entryDate
    ?
    <CheckCircle2 size={18}/>
    :
    <XCircle size={18}/>
}
        <span>

            {

                form.description.trim()

                ?

                "Description Added"

                :

                "Enter Description"

            }

        </span>

    </div>

    <div className={`check-item ${amount > 0 ? "complete" : "pending"}`}>

{
    form.entryDate
    ?
    <CheckCircle2 size={18}/>
    :
    <XCircle size={18}/>
}

        <span>

            {

                amount > 0

                ?

                "Amount Valid"

                :

                "Enter Amount"

            }

        </span>

    </div>

    <hr />

    {

        valid

        ?

        <div className="validation-success">

            ✓ Ready to save

        </div>

        :

        <div className="validation-warning">

            Complete all required fields

        </div>

    }

</div>

            </div>

        </div>


        {/* =====================================
                FOOTER
        ====================================== */}

        <div className="ledger-footer">

            <button

                className="cancel-btn"

                onClick={onClose}

            >

                Cancel

            </button>

            <button

                className="save-btn"

                disabled={!valid || saving}

                onClick={saveEntry}

            >

                <CircleDollarSign size={18}/>

                {

                    saving

                    ?

                    "Saving..."

                    :

                    editingEntry

?

"Update Ledger Entry"

:

"Add Ledger Entry"

                }

            </button>

        </div>

    </div>

</div>

);

}